export class AddTOSBaseRequest {
    AdminID: number;
    MemberID: number;
    Ignore: boolean;
}
